module.exports = __webpack_public_path__ + "img/sculpt1_thumb.bc1ff391.jpg";